<template>
  <div class="text-info font-weight-light">
    <b-modal
        id="dlgRole"
        ref="roleDialog"
        :title="$t('admin.settings.rolesManagement.roleDialogue')"
        :ok-title="$t('admin.settings.rolesManagement.modal.save')"
        :cancel-title="$t('general.cancel')"
        cancel-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        centered
        no-fade
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        @ok="onOkClicked"
        @shown="onShown"
    >
      <div  class="mt-3 mb-3"><input v-model="roleName" :placeholder="$t('admin.settings.rolesManagement.roleName')" maxlength="25ch"/></div>
      <v-multiselect-listbox style="width: 100%;" v-model="selectedRightsList" :options="rights"
                             :reduce-display-property="(option) => $t('admin.settings.rolesManagement.rights.'+option.name)"
                             :reduce-value-property="(option) => option.name"
                             :searchOptionsPlaceholder="$t('general.search').toString()"
                             :selectedOptionsPlaceholder="$t('general.search').toString()"
                             :selectedNoOptionsText="$t('general.select').toString()"
                             @change="selectedRightsListChanged()"></v-multiselect-listbox>
    </b-modal>
    <b-button type="button" class="btn btn-primary btn-secondary mt-3 mb-3 " @click="showModal('Add')" >{{ $t('admin.settings.rolesManagement.addRole') }} </b-button>
    <b-form-select class="mb-3" v-model="selectedRole"   @change="onRoleSelectionChange($event)" >
      <option
          v-for="(item, key) in roles"
          :key="key"
          :label="item.permanent? $t('project.settings.participants.roles.' + item.name.toLowerCase()) : item.name"
          :value="key">
      </option>
    </b-form-select>
    <b-table thead-class="stick-header" class="scrollable-table" responsive   :items="rights" :fields="tableFields" >
      <template slot="assigned" slot-scope="{ item: { assigned }}">
        <icon v-if="assigned" name="check"></icon>
        <!-- You can also use the font-awesome-icon component here -->
      </template>
      <template slot="name" slot-scope="{ item: { name }}">
        {{ $t('admin.settings.rolesManagement.rights.'+name) }}
      </template>
    </b-table>
    <p>
      <b-button type="button" class="mt-1 mr-1" @click="showModal('Clone')">{{ $t('admin.settings.rolesManagement.clone') }}</b-button>
      <span v-if="roles && !roles[selectedRole].permanent">
        <b-button type="button" class="mt-1 mr-1" @click="showModal('Edit')" >{{ $t('admin.settings.rolesManagement.edit') }}</b-button>
        <b-button type="button" class="mt-1 mr-1" @click="deleteRole">{{ $t('admin.settings.rolesManagement.delete') }}</b-button>
      </span>
    </p>
  </div>
</template>

<script>

import i18n from "@/i18n.bootstrap";
import {mapGetters} from "vuex";
import systemApi from "@/api/system";
import toastr from "toastr";

export default {
  name: "tab-Roles-Management",

  data() {
    return {
      selectedRightsList: [],
      roleName: '',
      currentRights: [],
      tableFields: [
        { key: 'name'},
        { key: 'assigned'}
      ],
      rights: [],
      selectedRole: 0,
      modalType: undefined
    }
  },

  created() {
    this.$store.dispatch('system/loadRoles').then(r => {
      systemApi.loadRights().then(result => {
        if (result && result.data) {
          this.rights = result.data.map(right => ({name: right, assigned: false}));
        }
        this.onRoleSelectionChange(0)
      });
    });
  },

  mounted() {
  },

  computed: {
    ...mapGetters({
      roles: 'system/roles',
    }),

    isShared() {
      return this.params.data.sharedId !== '';
    }
  },

  methods: {
    selectedRightsListChanged() {
      console.log(this.selectedRightsList);
    },
    showModal(type) {
      this.$root.$emit('bv::show::modal', 'dlgRole');
      this.modalType = type;
      if (type ==='Add'){
        this.selectedRightsList = [];
        this.roleName = '';
        console.log('Add Role');
      } else {
        this.selectedRightsList = [];
        this.roleName = type === 'Clone'? this.roles[this.selectedRole].name : this.roles[this.selectedRole].name;
        this.rights.forEach(right => {
          if (this.currentRights.indexOf(right.name) !== -1) {
            this.selectedRightsList.push(right.name);
          }
        })
      }
    },

    deleteRole() {
      this.$snotify.confirm(i18n.t('general.promptQuestion'), '', {
        closeOnClick: true,
        backdrop: 0.3,
        buttons: [
          { text: i18n.t('general.yes'), action: this.deleteRoleAction},
          { text: i18n.t('general.no') }
        ]
      });
    },
    onRoleSelectionChange(event) {
      console.log (event);
      this.currentRights = this.roles[event].permissions;
      this.selectedRightsList = [];
      this.rights.forEach(right => {
        if (this.currentRights.indexOf(right.name) !== -1){
          this.selectedRightsList.push(right.name);
          return right.assigned = true;
        } else {
          return right.assigned = false;
        }
      })
    },
    onOkClicked(event) {
      if(this.roleName !==''){
        if(this.modalType === 'Edit'){
          const id = this.roles[this.selectedRole].id;
          this.$store.dispatch('system/createRole', {role:{id, name: this.roleName, permissions: this.selectedRightsList}}).then(result =>{
            this.$store.dispatch('system/loadRoles').then(r => {
              systemApi.loadRights().then(result => {
                if (result && result.data) {
                  this.rights = result.data.map(right => ({name: right, assigned: false}));
                  this.onRoleSelectionChange(this.selectedRole)
                }
              });
            });
          });

        } else {
          this.$store.dispatch('system/createRole', {role:{name: this.roleName, permissions: this.selectedRightsList}}).then(newResult =>{
            const newId = newResult.data.id;
            this.$store.dispatch('system/loadRoles').then(r => {
              systemApi.loadRights().then(result => {
                if (result && result.data) {
                  this.rights = result.data.map(right => ({name: right, assigned: false}));
                  this.roles.forEach((role, index) => {
                    if(role.id === newId){
                      this.selectedRole = index;
                    }
                  })
                  this.onRoleSelectionChange(this.selectedRole)
                }
              });
            });
          });
        }
      }else{
        event.preventDefault();
        toastr.error(i18n.t('admin.settings.rolesManagement.errorAddNewRole'));
        console.log('AddNewRole error', { ...error });
        reject(error);

      }
    },

    onShown() {

    },
    deleteRoleAction(){
      const id = this.roles[this.selectedRole].id;
      this.$store.dispatch('system/deleteRole', id).then( result => {
        if(this.selectedRole > 0) {
          this.selectedRole--;
        }
        this.onRoleSelectionChange(this.selectedRole)
      });
    }
  },

}

</script>

<style scoped>
.scrollable-table{
  overflow-y: auto;
  display: block;
  height: 40vh;
  width: 100%;
}

</style>